export enum ContactsTag {
  FirstName = 'FirstName',
  LastName = 'LastName',
  PhoneNumber = 'PhoneNumber',
  PrimaryEmail = 'PrimaryEmail'
}

export const ContactsTagsMap = new Map<ContactsTag, { tag: string; prop: string }>([
  [ContactsTag.FirstName, { tag: 'First name', prop: 'FirstName' }],
  [ContactsTag.LastName, { tag: 'Last name', prop: 'LastName' }],
  [ContactsTag.PhoneNumber, { tag: 'Phone number', prop: 'PhoneNumber' }],
  [ContactsTag.PrimaryEmail, { tag: 'Primary email', prop: 'PrimaryEmail' }]
]);
